export default __webpack_public_path__ + "static/media/undraw_create_account.f854d79f.svg";